import React from 'react';
import Image from '../../../components/AppImage';
import type { Certification } from '../types';

const CertificationsSection: React.FC = () => {
  const certifications: Certification[] = [
    {
      id: '1',
      name: 'n8n Expert Partner',
      issuer: 'n8n.io',
      image: "https://n8n.io/brandguidelines/logo-dark.svg", 
      alt: 'n8n certification badge'
    },
    {
      id: '2',
      name: 'Make.com Gold Partner',
      issuer: 'Make.com',
      image: "https://images.ctfassets.net/un655fb9wln6/1k5wBPhbu5kXiaYlFWgEJE/b590772959bd510e64cf230ef37bba3e/Make-Logo-RGB.svg",
      alt: 'Make.com partner badge'
    },
    {
      id: '3',
      name: 'Meta Business Partner',
      issuer: 'Meta (WhatsApp)',
      image: "https://upload.wikimedia.org/wikipedia/commons/7/7b/Meta_Platforms_Inc._logo.svg",
      alt: 'Meta Business Partner badge'
    },
    {
      id: '4',
      name: 'OpenAI Developer',
      issuer: 'OpenAI',
      image: "https://upload.wikimedia.org/wikipedia/commons/4/4d/OpenAI_Logo.svg",
      alt: 'OpenAI Certified'
    },
    {
      id: '5',
      name: 'Google Cloud Partner',
      issuer: 'Google',
      image: "https://upload.wikimedia.org/wikipedia/commons/5/51/Google_Cloud_logo.svg",
      alt: 'Google Cloud Partner'
    },
    {
      id: '6',
      name: 'AWS Solutions Architect',
      issuer: 'Amazon Web Services',
      image: "https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg",
      alt: 'AWS Certified'
    }
  ];

  return (
    <section className="py-20 lg:py-28 bg-surface border-y border-border/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-2xl sm:text-3xl font-bold text-text-primary mb-4">
            Certified Excellence
          </h2>
          <p className="text-lg text-text-secondary">
            We don't just "know" these tools. We are certified partners recognized by the platforms themselves.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-8 items-center justify-items-center">
          {certifications.map((cert) => (
            <div
              key={cert.id}
              className="group flex flex-col items-center justify-center w-full max-w-[160px]"
            >
              <div className="w-20 h-20 mb-4 flex items-center justify-center filter grayscale opacity-60 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-500 transform group-hover:scale-110">
                <Image
                  src={cert.image}
                  alt={cert.alt}
                  className="w-full h-full object-contain"
                />
              </div>
              
              <div className="text-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 transform translate-y-2 group-hover:translate-y-0">
                <h3 className="text-xs font-bold text-text-primary">
                  {cert.name}
                </h3>
                <p className="text-[10px] text-text-secondary uppercase tracking-wider mt-1">
                  {cert.issuer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CertificationsSection;